import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuthStore } from "@/core/auth/auth-store";

interface Props {
  children: ReactNode;
}

/**
 * Blocks rendering of the wrapped route unless the user is authenticated.
 * Role-level gating is layered on top via `<RoleGate>` from the staff feature.
 */
export function ProtectedRoute({ children }: Props) {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();

  // While auth resolves, render nothing — the static splash in index.html keeps
  // showing because no terminal page has called `useAppReady` yet.
  if (status === "initial") return null;
  if (status === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
